<template>
  <v-container fluid class="pa-4">
    <v-row class="mb-4" align="center">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar paquetes"
          single-line
          hide-details
          clearable
          @click:clear="clearSearch"
        ></v-text-field>
      </v-col>
      <v-col cols="auto" v-if="!pending">
        <v-btn-toggle v-model="filterInactive" dense mandatory>
          <v-btn small value="active">
            <v-icon left small>mdi-check-circle</v-icon>
            Activos
          </v-btn>
          <v-btn small value="inactive">
            <v-icon left small>mdi-cancel</v-icon>
            Inactivos
          </v-btn>
          <v-btn small value="all">
            <v-icon left small>mdi-eye</v-icon>
            Todos
          </v-btn>
        </v-btn-toggle>
      </v-col>
      <v-col cols="auto" v-if="!pending">
        <PackageModal
          v-if="laboratory && !permissions.find((per) => per == 'lab_unedit')"
          :laboratory="laboratory"
          @packages_updated="getPackagesLab"
          class="mr-2"
        />
      </v-col>
      <v-col cols="auto" v-if="!pending">
        <v-btn
          v-if="laboratory && !permissions.find((per) => per == 'lab_unedit')"
          color="primary"
          small
          @click="openLogoStore = true"
        >
          <v-icon left>mdi-image-plus</v-icon>
          Gestionar iconos
        </v-btn>
      </v-col>
    </v-row>

    <div class="cards-container">
      <v-row dense v-if="paginatedPackages.length > 0">
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-for="item in paginatedPackages"
          :key="item._id"
        >
          <v-card
            :class="{
              'red-border': item.isDisabled,
              'mb-4': true,
              'elevation-2': true,
              'compact-card': true,
            }"
          >
            <v-card-title class="py-2 px-3 d-flex justify-space-between">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span class="text-subtitle-2 font-weight-bold" v-on="on">{{
                    item.name
                  }}</span>
                </template>
                <span>{{ item.nameEn }}</span>
              </v-tooltip>
              <v-chip v-if="item.isDisabled" x-small color="error"
                >Inactivo</v-chip
              >
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="py-2 px-3">
              <!-- <div class="d-flex justify-space-between mb-1"> -->
                <!-- <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="text-caption">
                        <v-icon x-small>mdi-flask</v-icon>
                        {{ item.kitType.map(kitTypeEs).join(", ") }}
                      </span>
                    </template>
                    <span>Tipo de kit</span>
                  </v-tooltip>
                </div> -->
                <!-- <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="text-caption">
                        <v-icon x-small>mdi-tag</v-icon>
                        {{ getCategoryEs(item.category) }}
                      </span>
                    </template>
                    <span>Categoría</span>
                  </v-tooltip>
                </div> -->
              <!-- </div> -->
              <div class="d-flex justify-space-between mb-1">
                <!-- <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        <v-chip
                          x-small
                          :color="item.isPlantTissue ? 'secondary' : 'warning'"
                          class="ma-0"
                        >
                          {{ item.isPlantTissue ? "Vegetal" : "Suelo" }}
                          <v-icon v-if="item.isPlantTissue" x-small right
                            >mdi-leaf</v-icon
                          >
                        </v-chip>
                      </span>
                    </template>
                    <span v-if="item.isPlantTissue && item.vegetalSampleTypes">
                      {{ getVegetalSampleType(item.vegetalSampleTypes) }}
                    </span>
                    <span v-else>Tipo de muestra</span>
                  </v-tooltip>
                </div> -->
                <div>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span
                        v-on="on"
                        class="text-caption text-celection"
                        @click="handlePackageSelection(item)"
                      >
                        <v-icon x-small>mdi-dna</v-icon>
                        {{ item.markersCount || 0 }} MM
                      </span>
                    </template>
                    <span>Marcadores moleculares</span>
                  </v-tooltip>
                </div>
              </div>
              <div class="mb-1">
                <div class="d-flex align-center">
                  <v-icon x-small class="mr-1">mdi-sprout</v-icon>
                  <span class="text-caption">Cultivos:</span>
                  <v-menu offset-y v-if="item.crop.length > 2">
                    <template v-slot:activator="{ on, attrs }">
                      <v-chip
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        class="ml-1"
                        :color="getCropColor(item.crop[0])"
                      >
                        {{ getCrop(item.crop[0]) }}
                        <v-icon x-small right v-if="item.crop.length > 1"
                          >mdi-dots-horizontal</v-icon
                        >
                      </v-chip>
                    </template>
                    <v-list dense>
                      <v-list-item
                        v-for="(crop, index) in item.crop"
                        :key="index"
                        class="pa-0"
                      >
                        <v-chip
                          x-small
                          :color="getCropColor(crop)"
                          class="ma-1"
                        >
                          {{ getCrop(crop) }}
                        </v-chip>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <template v-else>
                    <v-chip
                      v-for="(crop, index) in item.crop"
                      :key="index"
                      x-small
                      :color="getCropColor(crop)"
                      class="ml-1"
                    >
                      {{ getCrop(crop) }}
                    </v-chip>
                  </template>
                </div>
              </div>

              <v-row>
                <v-col>
                  <v-tooltip bottom v-if="item.zones && item.zones.length > 0">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="text-caption">
                        <v-icon x-small>mdi-map-marker</v-icon>
                        {{ item.zones.length }} región(es)
                      </span>
                    </template>
                    <span>{{ item.zones.join(", ") }}</span>
                  </v-tooltip>
                  <span v-else class="text-caption grey--text"
                    >Sin regiones</span
                  >
                </v-col>
                <v-col>
                  <v-tooltip bottom v-if="item.businessPartner">
                    <template v-slot:activator="{ on }">
                      <span v-on="on" class="text-caption">
                        <v-icon x-small>mdi-account</v-icon>
                        <!-- {{ item.businessPartner }} -->
                          Socios
                      </span>
                    </template>
                    <div
                      v-for="(distributor, index) in item.distributors"
                      :key="index"
                    >
                      <span>
                        {{ distributor.companyName }}
                      </span>
                      <v-spacer></v-spacer>
                    </div>
                    <!-- <span>Usuario CMDA: {{ item.businessPartner }}</span> -->
                  </v-tooltip>
                  <span v-else class="text-caption grey--text"
                    >Sin socios</span
                  >
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions
              class="py-1 px-2"
              v-if="!permissions.find((per) => per == 'lab_unedit')"
            >
              <v-spacer></v-spacer>
              <v-tooltip bottom v-if="!pending">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="item.isDisabled != true"
                    icon
                    x-small
                    color="primary"
                    @click.stop
                  >
                    <PackageModal
                      :package="item"
                      :laboratory="laboratory"
                      @packages_updated="getPackagesLab"
                      activator="icon"
                    />
                  </v-btn>
                </template>
                <span>Editar paquete</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!pending">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    icon
                    x-small
                    :color="item.isDisabled != true ? 'error' : 'warning'"
                    @click="
                      (currentPackageSelected = item),
                        (showVerificationModal = true)
                    "
                  >
                    <v-icon x-small>
                      {{
                        item.isDisabled != true
                          ? "mdi-delete"
                          : "mdi-delete-restore"
                      }}
                    </v-icon>
                  </v-btn>
                </template>
                <span v-if="item.isDisabled != true">Inhabilitar paquete</span>
                <span v-else>Habilitar paquete</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="item.isDisabled != true"
                    icon
                    x-small
                    color="blue"
                    @click="
                      (currentPackageSelected = item),
                        pending
                          ? (showTranferPackageToCMDAsModal = true)
                          : (showTransferPackageModal = true)
                    "
                  >
                    <v-icon x-small>mdi-transfer</v-icon>
                  </v-btn>
                </template>
                <span> Transferir paquete</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!pending">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    v-if="item.isDisabled != true"
                    icon
                    x-small
                    color="primary"
                    @click="
                      (currentPackageSelected = item),
                        (showTimeLinePackage = true)
                    "
                  >
                    <v-icon x-small>mdi-timeline-clock</v-icon>
                  </v-btn>
                </template>
                <span>Eventos en paquete </span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-row v-if="paginatedPackages.length == 0">
      <v-col cols="12" class="text-center">
        <p class="text-h6">No se encontraron paquetes</p>
      </v-col>
    </v-row>

    <v-row v-if="filteredPackages.length > itemsPerPage">
      <v-col cols="12" class="d-flex justify-center">
        <v-pagination
          v-model="page"
          :length="totalPages"
          :total-visible="7"
          circle
        ></v-pagination>
      </v-col>
    </v-row>

    <PackageLogosStore
      v-model="openLogoStore"
      v-if="openLogoStore"
      :laboratory="laboratory"
    />
    <VerificationModal
      v-model="showVerificationModal"
      v-if="showVerificationModal"
      @confirmation="deletePackage"
      :title="`¿Estás seguro que quieres ${
        currentPackageSelected
          ? currentPackageSelected.isDisabled == true
            ? 'habilitar'
            : 'inhabilitar'
          : ''
      } este paquete?`"
    />
    <TransferPackageModal
      v-model="showTransferPackageModal"
      v-if="showTransferPackageModal"
      @confirmation="transferPackage"
    />
    <time-line-package
      v-if="showTimeLinePackage"
      :currentPackage="currentPackageSelected"
      v-model="showTimeLinePackage"
    />
    <TranferPackageToCMDAsModal
      v-model="showTranferPackageToCMDAsModal"
      v-if="showTranferPackageToCMDAsModal"
      @confirmation="transferToLaboratories"
    />
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import PackageLogosStore from "@/components/cmda_admin/modals/PackageLogosStore";
import PackageModal from "@/components/cmda_admin/modals/PackageModal";
import VerificationModal from "@/components/cmda_admin/modals/VerificationModal";
import TransferPackageModal from "@/components/cmda_admin/modals/TransferPackageModal";
import TimeLinePackage from "./modals/TimeLinePackage.vue";
import TranferPackageToCMDAsModal from "./modals/TranferPackageToCMDAsModal.vue";

export default {
  components: {
    PackageModal,
    PackageLogosStore,
    VerificationModal,
    TransferPackageModal,
    TimeLinePackage,
    TranferPackageToCMDAsModal,
  },
  props: {
    laboratory: {
      type: Object,
      default: {
        name: "-",
      },
      required: true,
    },
    pending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
      page: 1,
      itemsPerPage: 12,
      dialog: false,
      packages: [],
      kitTypes: [
        {
          name: "HYBRID",
          esName: "HÍBRIDO",
        },
        {
          name: "QPCR",
          esName: "QPCR",
        },
      ],
      categories: [
        {
          name: "NUTRITION",
          esName: "Nutrición",
        },
        {
          name: "STRESS_TOLERANCE",
          esName: "Tolerancia a estres",
        },
        {
          name: "PATHOGEN_CONTROL",
          esName: "Control de patógenos",
        },
        {
          name: "BIOLOGICAL_RICHNESS",
          esName: "Riqueza biológica",
        },
        {
          name: "AGROCHEMICALS_USE",
          esName: "Uso de agroquímicos",
        },
        {
          name: "SOIL_AGGREGABILITY",
          esName: "Agregabilidad del suelo",
        },
        {
          name: "CO2_FIXATION",
          esName: "Fijación de CO2",
        },
        {
          name: "WATER_RETENTION",
          esName: "Retención de Agua",
        },
      ],
      sampleTypes: [
        {
          name: "soil",
          esName: "Suelo / Raíz",
        },
        {
          name: "vegetable",
          esName: "Material Vegetal",
        },
      ],
      vegetalSampleTypes: [
        { name: "Seedling", esName: "Plántula" },
        { name: "Root", esName: "Raíz" },
        { name: "Seed", esName: "Semilla" },
        { name: "Stem", esName: "Tallo" },
        { name: "Leaf", esName: "Hoja" },
        { name: "Fruit", esName: "Fruto" },
        { name: "Flower", esName: "Flor" },
      ],
      openLogoStore: false,
      showVerificationModal: false,
      currentPackageSelected: null,
      showTransferPackageModal: false,
      filterInactive: "active",
      showTimeLinePackage: false,
      showTranferPackageToCMDAsModal: false,
    };
  },
  computed: {
    ...mapState("laboratory", ["packageSelected"]),
    ...mapState("session", ["permissions"]),
    filteredPackages() {
      let filtered = this.packages;

      // Aplicar filtro de estado
      if (this.filterInactive === "active") {
        filtered = filtered.filter((pkg) => !pkg.isDisabled);
      } else if (this.filterInactive === "inactive") {
        filtered = filtered.filter((pkg) => pkg.isDisabled);
      }

      // Aplicar filtro de búsqueda
      if (this.search) {
        const searchTerm = this.search.toLowerCase();
        filtered = filtered.filter((pkg) => {
          return (
            (pkg.name && pkg.name.toLowerCase().includes(searchTerm)) ||
            (pkg.businessPartner &&
              pkg.businessPartner.toLowerCase().includes(searchTerm)) ||
            (pkg.category &&
              this.getCategoryEs(pkg.category)
                .toLowerCase()
                .includes(searchTerm)) ||
            (pkg.kitType &&
              pkg.kitType.some((kt) =>
                this.kitTypeEs(kt).toLowerCase().includes(searchTerm)
              )) ||
            (pkg.crop &&
              pkg.crop.some((c) =>
                this.getCrop(c).toLowerCase().includes(searchTerm)
              )) ||
            (pkg.zones &&
              pkg.zones.some((z) => z.toLowerCase().includes(searchTerm)))
          );
        });
      }

      return filtered;
    },
    totalPages() {
      return Math.ceil(this.filteredPackages.length / this.itemsPerPage);
    },
    paginatedPackages() {
      const start = (this.page - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredPackages.slice(start, end);
    },
  },
  watch: {
    search() {
      this.page = 1; // Resetear a la primera página al buscar
    },
    filterInactive() {
      this.page = 1;
    },
    laboratory: {
      handler(newVal) {
        if (newVal && newVal._id) {
          this.getPackagesLab();
        }
      },
      immediate: true,
    },
    packageSelected: {
      async handler(newVal) {
        if (!newVal) {
          await this.getPackagesLab();
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    await this.getPackagesLab();
  },
  methods: {
    ...mapMutations("alerts", ["SET_ALERT_TYPE"]),
    ...mapActions("laboratory", [
      "getPackages",
      "disablePackage",
      "transferringPackage",
      "transferPackageToLaboratories"
    ]),
    clearSearch() {
      this.search = "";
    },
    approachEs(approach) {
      const approachs = {
        taxonomic: "Taxonomico",
        functional: "Funcional",
      };
      return approachs[approach];
    },
    serviceEs(service) {
      const services = {
        monitoring: "Monitoreo",
        prescription: "Prescripción",
      };
      return services[service];
    },
    kitTypeEs(kitType) {
      const types = {
        HYBRID: "Híbrido",
        QPCR: "QPCR",
      };
      return types[kitType];
    },
    getCategoryEs(category) {
      const categories = {
        NUTRITION: "Nutrición",
        STRESS_TOLERANCE: "Tolerancia a estrés",
        PATHOGEN_CONTROL: "Control de patógenos",
        BIOLOGICAL_RICHNESS: "Nutrición",
        AGROCHEMICALS_USE: "Nutrición",
        SOIL_AGGREGABILITY: "Nutrición",
        CO2_FIXATION: "Nutrición",
        WATER_RETENTION: "Nutrición",
      };
      return categories[category];
    },
    getCrop(value) {
      let template = "";
      const crop = {
        olive: "Aceituna",
        chard: "Acelga",
        achiote: "Achiote",
        agave: "Agave",
        avocado: "Aguacate",
        garlic: "Ajo",
        sesame: "Ajonjolí",
        basil: "Albahaca",
        artichoke: "Alcachofa",
        alcatraz: "Alcatraz",
        shrunkenAlfalfa: "Alfalfa achicalada",
        greenAlfalfa: "Alfalfa verde",
        cotton: "Algodón",
        almond: "Almendro",
        birdseed: "Alpiste",
        amaranth: "Amaranto",
        anise: "Anís",
        celery: "Apio",
        blueberry: "Arándano",
        myrtle: "Arrayán",
        rice: "Arroz",
        greenForageOats: "Avena forrajera en verde",
        oatGrain: "Avena grano",
        bamboo: "Bambú",
        eggplant: "Berenjena",
        beetroot: "Betabel",
        broccoli: "Brocoli",
        peanut: "Cacahuate",
        cocoa: "Cacao",
        cherryCoffee: "Café cereza",
        pumpkin: "Calabaza",
        sweetPotato: "Camote",
        sugarCane: "Caña de azúcar",
        canola: "Canola",
        carambolo: "Carambolo",
        safflower: "Cártamo",
        barley: "Cebada",
        greenForageBarley: "Cebada forrajera en verde",
        onion: "Cebolla",
        chives: "Cebollín",
        ryeGrain: "Centeno grano",
        cherry: "Cereza",
        chabacano: "Chabacano",
        pea: "Chícharo",
        squash: "Chayote",
        chia: "Chía",
        chilacayote: "Chilacayote",
        chillyPepper: "Chile / Pimiento",
        custardApple: "Chirimoya",
        coriander: "Cilantro",
        plum: "Ciruela",
        coconutFruit: "Coco fruta",
        cabbage: "Col (repollo)",
        brusselsSprouts: "Col de Bruselas",
        cauliflower: "Coliflor",
        cumin: "Comino",
        chrysanthemum: "Crisantemo (planta)",
        peach: "Durazno",
        date: "Dátil",
        greenBean: "Ejote",
        cornCob: "Elote",
        dill: "Eneldo",
        epazote: "Epazote",
        asparagus: "Espárrago",
        spicesAndMedicinals: "Especias y medicinales",
        spinach: "Espinaca",
        raspberry: "Frambuesa",
        strawberry: "Fresa",
        bean: "Frijol",
        chickpea: "Garbanzo",
        sunflower: "Girasol",
        pomegranate: "Granada",
        soursop: "Guanábana",
        guava: "Guayaba",
        henequen: "Henequén",
        peppermint: "Hierbabuena",
        aromaticHerbs: "Hierbas aromáticas",
        fig: "Higo",
        jamaica: "Jamaica",
        ginger: "Jenjibre",
        jicama: "Jícama",
        lettuce: "Lechuga",
        lentil: "Lenteja",
        lime: "Lima",
        lemon: "Limón",
        linseed: "Linaza",
        litchi: "Litchi",
        corn: "Maíz",
        macadamia: "Macadamia",
        maguey: "Maguey",
        mamey: "Mamey",
        tangerine: "Mandarina",
        mango: "Mango",
        mangosteen: "Mangostán",
        chamomile: "Manzanilla",
        appleTree: "Manzano",
        passionFruit: "Maracuyá",
        daisyFlower: "Margarita",
        marjoram: "Mejorana",
        melon: "Melón",
        quince: "Membrillo",
        mint: "Menta",
        moringa: "Moringa",
        turnip: "Nabo",
        nanche: "Nanche",
        napa: "Napa",
        orange: "Naranja",
        medlar: "Níspero",
        nochebuena: "Nochebuena (planta)",
        walnut: "Nogal",
        noni: "Noni",
        nopal: "Nopal",
        oregano: "Orégano",
        ornamental: "Ornamentales",
        orchid: "Orquídea (planta)",
        oilPalm: "Palma africana o de aceite",
        potato: "Papa",
        papaya: "Papaya",
        grasslands: "Pastizales",
        matGrass: "Pasto tapete (m2)",
        pasturesAndMeadows: "Pastos y praderas",
        cucumber: "Pepino",
        pearTree: "Peral",
        parsley: "Perejil",
        peron: "Perón",
        persimony: "Persimonio",
        pepper: "Pimienta",
        pineapple: "Piña",
        pinion: "Piñón",
        pistache: "Pistache",
        pitaya: "Pitaya",
        banana: "Plátano",
        pore: "Poro",
        radish: "Rábano",
        rambutan: "Rambután",
        romerito: "Romerito",
        rosemary: "Romero",
        aloe: "Sábila",
        watermelon: "Sandía",
        sorghum: "Sorgo",
        soy: "Soya",
        stevia: "Stevia",
        tobacco: "Tabaco",
        tamarind: "Tamarindo",
        tejocote: "Tejocote",
        tomato: "Tomate Rojo (jitomate)",
        greenTomato: "Tomate Verde",
        thyme: "Tomillo",
        grapefruit: "Toronja (pomelo)",
        clover: "Trébol",
        wheat: "Trigo",
        dutchTulip: "Tulipán holandés",
        tuna: "Tuna",
        grape: "Uva",
        vanilla: "Vainilla",
        purslane: "Verdolaga",
        vine: "Vid",
        cassavaFood: "Yuca alimenticia",
        carrot: "Zanahoria",
        sapodilla: "Zapote",
        blackberry: "Zarzamora",
        zempoalxochitl: "Zempoalxochitl",
        fallow: "Barbecho",
        other: "Otro",
      };
      let cropName = crop[value];
      if (typeof cropName != "undefined") {
        template = cropName;
      } else {
        template = "Sin cultivo";
      }
      return template;
    },
    getCropColor(value) {
      let template = "";
      const crop = {
        olive: "green lighten-4",
        chard: "green lighten-4",
        achiote: "orange lighten-4",
        agave: "brown lighten-4",
        avocado: "green lighten-4",
        garlic: "white",
        sesame: "brown lighten-4",
        basil: "green lighten-4",
        artichoke: "green lighten-4",
        alcatraz: "purple lighten-4",
        shrunkenAlfalfa: "green lighten-4",
        greenAlfalfa: "green lighten-4",
        cotton: "white",
        almond: "brown lighten-4",
        birdseed: "brown lighten-4",
        amaranth: "red lighten-4",
        anise: "brown lighten-4",
        celery: "green lighten-4",
        blueberry: "blue lighten-4",
        myrtle: "green lighten-4",
        rice: "white",
        greenForageOats: "green lighten-4",
        oatGrain: "brown lighten-4",
        bamboo: "green lighten-4",
        eggplant: "purple lighten-4",
        beetroot: "red lighten-4",
        broccoli: "green lighten-4",
        peanut: "brown lighten-4",
        cocoa: "brown lighten-4",
        cherryCoffee: "red lighten-4",
        pumpkin: "orange lighten-4",
        sweetPotato: "orange lighten-4",
        sugarCane: "green lighten-4",
        canola: "yellow lighten-4",
        carambolo: "yellow lighten-4",
        safflower: "yellow lighten-4",
        barley: "brown lighten-4",
        greenForageBarley: "green lighten-4",
        onion: "purple lighten-4",
        chives: "green lighten-4",
        ryeGrain: "brown lighten-4",
        cherry: "red lighten-4",
        chabacano: "orange lighten-4",
        pea: "green lighten-4",
        squash: "green lighten-4",
        chia: "brown lighten-4",
        chilacayote: "green lighten-4",
        chillyPepper: "red lighten-4",
        custardApple: "green lighten-4",
        coriander: "green lighten-4",
        plum: "purple lighten-4",
        coconutFruit: "brown lighten-4",
        cabbage: "green lighten-4",
        brusselsSprouts: "green lighten-4",
        cauliflower: "white",
        cumin: "brown lighten-4",
        chrysanthemum: "purple lighten-4",
        peach: "orange lighten-4",
        date: "brown lighten-4",
        greenBean: "green lighten-4",
        cornCob: "yellow lighten-4",
        dill: "green lighten-4",
        epazote: "green lighten-4",
        asparagus: "green lighten-4",
        spicesAndMedicinals: "green lighten-4",
        spinach: "green lighten-4",
        raspberry: "red lighten-4",
        strawberry: "red lighten-4",
        bean: "brown lighten-4",
        chickpea: "brown lighten-4",
        sunflower: "yellow lighten-4",
        pomegranate: "red lighten-4",
        soursop: "green lighten-4",
        guava: "green lighten-4",
        henequen: "brown lighten-4",
        peppermint: "green lighten-4",
        aromaticHerbs: "green lighten-4",
        fig: "purple lighten-4",
        jamaica: "red lighten-4",
        ginger: "brown lighten-4",
        jicama: "brown lighten-4",
        lettuce: "green lighten-4",
        lentil: "brown lighten-4",
        lime: "green lighten-4",
        lemon: "yellow lighten-4",
        linseed: "brown lighten-4",
        litchi: "red lighten-4",
        corn: "yellow lighten-4",
        macadamia: "brown lighten-4",
        maguey: "green lighten-4",
        mamey: "orange lighten-4",
        tangerine: "orange lighten-4",
        mango: "orange lighten-4",
        mangosteen: "purple lighten-4",
        chamomile: "white",
        appleTree: "green lighten-4",
        passionFruit: "purple lighten-4",
        daisyFlower: "white",
        marjoram: "green lighten-4",
        melon: "green lighten-4",
        quince: "orange lighten-4",
        mint: "green lighten-4",
        moringa: "green lighten-4",
        turnip: "white",
        nanche: "yellow lighten-4",
        napa: "green lighten-4",
        orange: "orange lighten-4",
        medlar: "orange lighten-4",
        nochebuena: "red lighten-4",
        walnut: "brown lighten-4",
        noni: "green lighten-4",
        nopal: "green lighten-4",
        oregano: "green lighten-4",
        ornamental: "green lighten-4",
        orchid: "purple lighten-4",
        oilPalm: "brown lighten-4",
        potato: "yellow lighten-4",
        papaya: "orange lighten-4",
        grasslands: "green lighten-4",
        matGrass: "green lighten-4",
        pasturesAndMeadows: "green lighten-4",
        cucumber: "green lighten-4",
        pearTree: "green lighten-4",
        parsley: "green lighten-4",
        peron: "green lighten-4",
        persimony: "orange lighten-4",
        pepper: "green lighten-4",
        pineapple: "yellow lighten-4",
        pinion: "brown lighten-4",
        pistache: "green lighten-4",
        pitaya: "pink lighten-4",
        banana: "yellow lighten-4",
        pore: "green lighten-4",
        radish: "red lighten-4",
        rambutan: "red lighten-4",
        romerito: "green lighten-4",
        rosemary: "green lighten-4",
        aloe: "green lighten-4",
        watermelon: "green lighten-4",
        sorghum: "brown lighten-4",
        soy: "brown lighten-4",
        stevia: "green lighten-4",
        tobacco: "brown lighten-4",
        tamarind: "brown lighten-4",
        tejocote: "orange lighten-4",
        tomato: "red lighten-4",
        greenTomato: "green lighten-4",
        thyme: "green lighten-4",
        grapefruit: "pink lighten-4",
        clover: "green lighten-4",
        wheat: "brown lighten-4",
        dutchTulip: "purple lighten-4",
        tuna: "red lighten-4",
        grape: "purple lighten-4",
        vanilla: "brown lighten-4",
        purslane: "green lighten-4",
        vine: "green lighten-4",
        cassavaFood: "brown lighten-4",
        carrot: "orange lighten-4",
        sapodilla: "brown lighten-4",
        blackberry: "purple lighten-4",
        zempoalxochitl: "orange lighten-4",
        fallow: "brown lighten-4",
        other: "grey lighten-4",
      };
      let cropName = crop[value];
      if (typeof cropName != "undefined") {
        template = cropName;
      } else {
        template = "default";
      }
      return template;
    },
    async getPackagesLab() {
      try {
        if (this.pending) {
          const req = await this.getPackages({ isPending: true });
          this.packages = req.packages;
          return;
        }
        if (!this.laboratory._id) return;
        const req = await this.getPackages({ laboratory: this.laboratory._id });
        if (req.error) throw req;
        this.packages = req.packages;
        this.$emit("packages_updated", req.packages);
      } catch (error) {
        console.error(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: error.message,
          timeout: 4000,
        });
      }
    },
    getVegetalSampleType(types) {
      let label = "";
      if (!types) {
        return "-";
      }
      for (let index = 0; index < types.length; index++) {
        const element = types[index];
        const typeData = this.vegetalSampleTypes.find((t) => t.name == element);
        if (index == types.length - 1) {
          label += typeData.esName;
        } else {
          label += `${typeData.esName}, `;
        }
      }
      return label;
    },
    async deletePackage() {
      try {
        let payload = {
          _id: this.currentPackageSelected._id,
          isDisabled:
            typeof this.currentPackageSelected.isDisabled != "undefined"
              ? this.currentPackageSelected.isDisabled
                ? false
                : true
              : true,
        };
        await this.disablePackage(payload);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Actividad de paquete actualizada",
          timeout: 4000,
        });
        await this.getPackagesLab();
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: error.message,
          timeout: 4000,
        });
      }
    },
    async transferPackage(lab) {
      try {
        let payload = {
          _id: this.currentPackageSelected._id,
          laboratoryId: lab._id,
        };
        await this.transferringPackage(payload);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Paquete transferido con exito",
          timeout: 4000,
        });
        await this.getPackagesLab();
        this.$emit("updateTable");
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: error.message,
          timeout: 4000,
        });
      }
    },
    async transferToLaboratories(labIds) {
      try {
        let payload = {
          packageId: this.currentPackageSelected._id,
          laboratories: labIds,
        };
        await this.transferPackageToLaboratories(payload);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "success",
          text: "Paquete transferido con exito",
          timeout: 4000,
        });
        await this.getPackagesLab();
      } catch (error) {
        console.log(error);
        this.SET_ALERT_TYPE({
          visible: true,
          type: "error",
          text: error.message,
          timeout: 4000,
        });
      }
    },
    handlePackageSelection(item) {
      this.$emit("package_selected", item);
    },
  },
};
</script>

<style scoped>
.cards-container {
  max-height: calc(100vh - 220px);
  overflow-y: auto;
  padding: 4px;
}

.compact-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.compact-card .v-card__title {
  padding: 8px 12px;
  font-size: 0.875rem;
}

.compact-card .v-card__text {
  padding: 8px 12px;
  flex-grow: 1;
}

.compact-card .v-card__actions {
  padding: 4px 8px;
}

.red-border {
  border-left: 4px solid #ff5252;
}

.text-caption {
  font-size: 0.75rem;
  line-height: 1.25;
}

/* Personalización del scroll */
.cards-container::-webkit-scrollbar {
  width: 8px;
}

.cards-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.cards-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.cards-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.text-celection {
  cursor: pointer;
}
</style>
